import React, { useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Spin } from 'grab-ui';
import styles from './styles.less';
import { ovoCallbackMessageType } from './common';

const OVOCallback = ({ location }) => {
  const query = new URLSearchParams(location.search);
  const response = query.get('response');
  const parsedResponse = useMemo(
    () => {
      try {
        return JSON.parse(response);
      } catch (e) {
        return null;
      }
    },
    [response],
  );

  useEffect(
    () => {
      if (parsedResponse) {
        window.parent.postMessage(
          {
            ...parsedResponse,
            type: ovoCallbackMessageType,
          },
          '*',
        );
      }
    },
    [parsedResponse],
  );

  return (
    <div className={styles.OVOCallback}>
      <Spin />
    </div>
  );
};

OVOCallback.propTypes = {
  location: PropTypes.shape({}).isRequired,
};

export default withRouter(OVOCallback);
